import IconButton from 'components/common/IconButton';
import {
  Button,
  Card,
  Col,
  Form,
  OverlayTrigger,
  Row,
  Spinner,
  Tooltip
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import EmailShareModal from './EmailShareModal';
import { getExcelSharedProperties } from 'redux/propsSlice';

const SelectShareBar = ({ selected, setSelected, handleCheckbox, type }) => {
  // * States
  const [emailModal, setEmailModal] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const dispatch = useDispatch();

  const exportExcel = async () => {
    setLoadingExport(true);
    const response = await dispatch(getExcelSharedProperties(selected));
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    const isoDate = new Date().toISOString().slice(0, 10);
    a.href = url;
    a.download = `compartidas_${isoDate}.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    setLoadingExport(false);
    setSelected([]);
  };

  return (
    <>
      {/* Select bar */}
      <Card className="mb-1 bg-white">
        <Card.Body>
          <Row>
            <Col xs={12} className="d-flex justify-content-between">
              <div className="d-flex align-items-center" style={{ gap: 10 }}>
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip>
                      {selected.length
                        ? 'Deseleccionar todas'
                        : 'Seleccionar todas'}
                    </Tooltip>
                  }
                >
                  <Form.Check
                    type="checkbox"
                    onChange={handleCheckbox}
                    checked={!!selected.length}
                  />
                </OverlayTrigger>

                {/* Email Share */}
                <IconButton
                  buttonSize="sm"
                  icon="envelope"
                  onClick={() => setEmailModal(true)}
                  variant="light"
                  className="px-3"
                  disabled={selected.length === 0}
                >
                  <span>Compartir por correo</span>
                </IconButton>
                {loadingExport ? (
                  <IconButton
                    buttonSize="sm"
                    onClick={async () => await exportExcel()}
                    variant="light"
                    className="px-3 text-align-center disabled"
                    disabled={true}
                  >
                    <Spinner animation="border" size="sm" />
                    <span>Exportar en excel</span>
                  </IconButton>
                ) : (
                  <IconButton
                    buttonSize="sm"
                    icon="file"
                    onClick={async () => await exportExcel()}
                    variant="light"
                    className="px-3"
                    disabled={selected.length === 0}
                  >
                    <span>Exportar en excel</span>
                  </IconButton>
                )}
              </div>
              <div>
                <span>
                  {selected.length}{' '}
                  {selected.length === 1 ? 'seleccionada' : 'seleccionadas'}
                </span>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Email Modal */}
      {emailModal && (
        <EmailShareModal
          type={type}
          selected={selected}
          emailModal={emailModal}
          setShow={setEmailModal}
          setSelected={setSelected}
        />
      )}
    </>
  );
};

SelectShareBar.propTypes = {
  selected: PropTypes.array.isRequired,
  setSelected: PropTypes.func.isRequired,
  handleCheckbox: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired
};

export default SelectShareBar;
